import { useEffect } from 'react';
import { useWtrDispatch, useWtrStore } from 'redux/hooks';
import { notifyLoginSuccess } from 'analytics/login-tracking';
import { addToTrolleyPostAuthentication } from 'redux/modules/sessions/actions/add-to-trolley-post-authentication';
import { favouritePostAuthentication } from 'redux/modules/sessions/actions/favourite-post-authentication';
import { addInteractiveElement } from 'utils/add-interactive-element';
import setupTestEntryPoints from 'utils/test-entry-points';

/**
 * Fires once, right after the first client hydrate.
 * Prevents hydration-mismatch caused by updating the store too early.
 */
const PostAuthEffects = () => {
  const dispatch = useWtrDispatch();
  const store = useWtrStore();

  useEffect(() => {
    dispatch(notifyLoginSuccess());
    dispatch(addToTrolleyPostAuthentication());
    dispatch(favouritePostAuthentication());
    addInteractiveElement();
    setupTestEntryPoints(store);
  }, [dispatch, store]);

  return null;
};

export default PostAuthEffects;
